import { useState } from 'react';
import { CircleHelp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/contexts/AuthContext';
import { useOnboarding } from '@/hooks/use-onboarding';
import { SUPPORT_CATEGORY_LABELS, type SupportCategory } from '@/lib/support-context';
import { SupportDialog } from '@/components/support/SupportDialog';
import { OnboardingDialog } from './OnboardingDialog';

/**
 * Ícone de ajuda do TopBar: primeiros passos (onboarding, que também abre sozinho
 * no primeiro acesso) e canais de suporte (problema / sugestão / dúvida).
 */
export function HelpButton() {
  const { user, selectedClinic } = useAuth();
  const { open, show, close } = useOnboarding(user?.id, selectedClinic?.id);
  const [category, setCategory] = useState<SupportCategory | null>(null);

  return (
    <>
      <DropdownMenu>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Ajuda e suporte">
                <CircleHelp className="w-5 h-5 text-muted-foreground" />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>Ajuda e suporte</TooltipContent>
        </Tooltip>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={show}>Primeiros passos</DropdownMenuItem>
          <DropdownMenuSeparator />
          {(Object.keys(SUPPORT_CATEGORY_LABELS) as SupportCategory[]).map((c) => (
            <DropdownMenuItem key={c} onSelect={() => setCategory(c)}>
              {SUPPORT_CATEGORY_LABELS[c].title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      <OnboardingDialog open={open} onClose={close} />
      <SupportDialog category={category} onClose={() => setCategory(null)} />
    </>
  );
}
